import { OwnContractCredentialsMapper } from './OwnContractCredentials/OwnContractCredentialsMapper.js';
import { getPaymentMethods } from '../../models/Payment/PaymentMethod.js';

class OwnContractMapper {
  static createFromResponse(_ref) {
    let {
      client_id,
      contract_model_id,
      credentials,
      id
    } = _ref;
    return {
      clientId: client_id,
      contractModelId: contract_model_id,
      credentials: OwnContractCredentialsMapper.createModelFromResponse(credentials),
      id
    };
  }
  static registrationPayload(_ref2) {
    let {
      contractModelId,
      credentials
    } = _ref2;
    return {
      contract_model_id: contractModelId,
      credentials: OwnContractCredentialsMapper.createOwnContractCredentialsApiParams(credentials)
    };
  }
  static linkServicesPayload(_ref3) {
    let {
      contractModelId,
      services
    } = _ref3;
    return {
      contract_model_id: contractModelId,
      services
    };
  }
  static createOwnContractIdModelFromResponse(data) {
    return {
      contractId: data.contract_id
    };
  }
  static createDeactivateOwnContractModelFromResponse(data) {
    return {
      contractId: data.contract_id,
      ...(data.payment_methods && {
        paymentMethods: getPaymentMethods(data.payment_methods)
      })
    };
  }
}

export { OwnContractMapper };
//# sourceMappingURL=OwnContractMapper.js.map
